import { moveToFulfilled, replaceFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ResolveGroupMembershipFromNotificationFulfilledAction } from '../../domains/groupResolveMembershipRequest/actions.types';
import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreAction } from '../../domains/notificationPaginations/actions.types';

import { Notification, NotificationSubtype, Notifications, RequestedGroupJoinNotificationDetails } from './types';

export type NotificationAction =
  | MarkAllNotificationsAsSeenFulfilledAction
  | ResolveGroupMembershipFromNotificationFulfilledAction
  | NotificationLoadMoreAction;

const initialState: Notifications = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type OptimisticallyUpdateRequestedGroupMembership = (
  state: Notifications,
  notificationId: Notification['id']
) => Notifications;
const optimisticallyUpdateRequestedGroupMembership: OptimisticallyUpdateRequestedGroupMembership = (
  state,
  notificationId
) => {
  const notification = state.fulfilled.byId[notificationId];

  if (notification == null || notification.subtype !== NotificationSubtype.RequestedGroupJoinNotification) {
    return state;
  }

  const details: RequestedGroupJoinNotificationDetails = {
    ...notification.details,
    isResolved: true,
  };

  return update(state, notificationId, { details });
};

const reducer: Reducer<Notifications, NotificationAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return replaceFulfilled(state, action.payload.entities.notifications);
    case 'GROUP.RESOLVE_MEMBERSHIP_REQUEST_FULFILLED':
      return optimisticallyUpdateRequestedGroupMembership(state, action.payload.notificationId);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.notifications);
    default:
      return state;
  }
};

export default reducer;
